import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { BID_VALIDATION_RESULTS } from '../api/vip-api-constants';

export const CATEGORIES = {
    VIEW_ITEM: 'View item',
    BIDDING: 'Bidding',
    CART: 'Cart',
    CHECKOUT_BIN: 'Checkout bin'
};

const trackAction = (category, action, label) => {
    GtmService.trackAction(category, action, label);
};

export const trackBiddingConfirmBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Bid button', 'Bekräfta bud');

export const trackBiddingShowEnterBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Show', 'EnterBid');

export const trackBiddingShowConfirmBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Show', 'ConfirmBid');

export const trackBiddingShowChangeMaxBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Show', 'ChangeMaxBid');

export const trackBiddingQuickBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Bid button', 'Lägg snabbud');

export const trackBiddingNewMaxBid = () =>
    trackAction(CATEGORIES.BIDDING, 'Bid button', 'Lägg maxbud');

export const trackNewBid = () =>
    trackAction(CATEGORIES.VIEW_ITEM, 'Bid button', 'Lägg bud');

export const trackNewMaxBid = () =>
    trackAction(CATEGORIES.VIEW_ITEM, 'Bid button', 'Ändra maxbud');

export const trackOpenCheckoutBin = () =>
    trackAction(CATEGORIES.CHECKOUT_BIN, 'Show', 'Open BIN modal');

export const trackConfirmBin = () =>
    trackAction(
        CATEGORIES.CHECKOUT_BIN,
        'Bin navigation',
        'Confirm BIN purchase'
    );

export const trackPayBin = () =>
    trackAction(CATEGORIES.CHECKOUT_BIN, 'Bin navigation', 'Pay BIN');

export const trackKeepShopping = () =>
    trackAction(CATEGORIES.CHECKOUT_BIN, 'Bin navigation', 'Keep shopping');

export const trackBinError = () =>
    trackAction(CATEGORIES.CHECKOUT_BIN, 'Bin navigation', 'Error');

export const trackBidPlaced = (
    itemId,
    validationCode,
    isMaxBid,
    potentialBidChange,
    bidId,
    transactionTotal,
    weightedBidValue
) => {
    switch (validationCode) {
        case BID_VALIDATION_RESULTS.LEADING_BIDDER:
        case BID_VALIDATION_RESULTS.HIGHER_BIDDER_EXISTS:
            // LeadingBidder.cshtml and HigherBidderExists renders _PlaceBidDataLayerTracking.cshtml
            // which has this tracking.
            GtmService.push({
                event: 'auctionEvent',
                transactionTotal: `${transactionTotal}`
            });
            GtmService.trackAction(
                CATEGORIES.BIDDING,
                'PlacedBidPotential',
                isMaxBid ? 'MaxBid' : 'MinBid',
                `${potentialBidChange}`,
                true
            );
            GtmService.push({
                event: 'bidPlacedEvent',
                itemId: `${itemId}`,
                placedBidId: `${bidId}`,
                bidValue: `${transactionTotal}`,
                weightedBidValue: `${weightedBidValue}`
            });
            break;
    }
    GtmService.trackAction(
        CATEGORIES.BIDDING,
        'Show',
        validationCode,
        '0',
        true
    );
};

export const trackWishlist = (itemId, isAdding) => {
    const action = isAdding ? 'Added to wish list' : 'Removed from wish list';
    const label = isAdding
        ? `Added item: ${itemId}`
        : `Removed item: ${itemId}`;
    GtmService.trackAction('View item', action, label);
};

export const trackAddToCart = (sellerMemberAlias, fixedPrice, redirectUrl) =>
    GtmService.trackLinkClickAndGotoUrl(
        CATEGORIES.CART,
        'Add to cart',
        `Added ${sellerMemberAlias}`,
        redirectUrl,
        fixedPrice
    );

const defaultClientId = '2ab8b9da-aeb2-4790-86cf-bd1cd3c51453';
export const getGaTrackingData = () => {
    /* global gaData */
    return {
        clientId:
            ga && ga.getAll && ga.getAll()?.length > 0
                ? ga.getAll()[0].get('clientId') || defaultClientId
                : defaultClientId,
        trackingIds:
            typeof gaData !== 'undefined' ? [Object.keys(gaData)[1]] : []
    };
};
